import { generateKeys, generateLocalization } from '../utils';
const regulatorsNames = generateLocalization('regulatorsNames', generateKeys({
    cysec: {
        value: 'cysec',
        label: 'Cyprus Securities and Exchange Commission',
        localization: { id: '', defaultMessage: '' },
    },
    fsc: {
        value: 'fsc',
        label: 'Financial Services Commission',
        localization: { id: '', defaultMessage: '' },
    },
    vfsc: {
        value: 'vfsc',
        label: 'Financial Services Authority',
        localization: { id: '', defaultMessage: '' },
    },
    fsca: {
        value: 'fsca',
        label: 'Financial Sector Conduct Authority',
        localization: { id: '', defaultMessage: '' },
    },
    cfc: {
        value: 'cfc',
        label: 'Mwali International Services Authority',
        localization: { id: '', defaultMessage: '' },
    },
}));
export const regulators = generateKeys({
    cysec: {
        value: 'cysec',
        label: 'CySEC',
        code: '1',
        literal: 'cysec',
        license: '199/13',
        country: 'Cyprus',
        name: regulatorsNames.cysec,
    },
    fsc: {
        value: 'fsc',
        label: 'FSC',
        code: '3',
        literal: 'mauritius',
        license: 'C116016172',
        country: 'Mauritius',
        name: regulatorsNames.fsc,
    },
    vfsc: {
        value: 'vfsc',
        label: 'FSA',
        code: '4',
        literal: 'vanuatu',
        license: 'SD047',
        country: 'Seychelles',
        name: regulatorsNames.vfsc,
    },
    fsca: {
        value: 'fsca',
        label: 'FSCA',
        code: '5',
        literal: 'southAfrica',
        license: 'SD047',
        country: 'South Africa',
        name: regulatorsNames.fsca,
    },
    cfc: {
        value: 'cfc',
        label: 'MISA',
        code: '6',
        literal: 'comoros',
        license: 'T2023244',
        country: 'Comoros',
        name: regulatorsNames.cfc,
    },
});
